// extracted by mini-css-extract-plugin
export default {"title":"A6sV7qAZUq","tall":"RL6ECKOYCK"};